<template>
  <v-container>
    <v-layout column align-center>
      <h1>404</h1>
      <v-flex xs12>
        <h3>Ресурс не найден</h3>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'notFound'
}
</script>
